// Page Management Enums
export enum PageStatus {
  DRAFT = 1,
  PUBLISHED = 2,
  ARCHIVED = 3,
}

export enum PageLayout {
  DEFAULT_LAYOUT = 1,
  FULL_WIDTH = 2,
  LANDING_PAGE = 3,
}

// Additional enums for API compatibility
export enum pageStatusEnum {
  "Draft" = 1,
  "Published" = 2,
  "Archived" = 3,
}

export enum pageTypeEnum {
  "Default Layout" = 1,
  "Full Width" = 2,
  "Landing Page" = 3,
}


// Page Management Interfaces
export interface PageMetadata {
  description?: string;
  keywords?: string[];
}

export interface PageStatusObject {
  id: number;
  name: string;
}

export interface PageLayoutObject {
  id: number;
  name: string;
}

export interface PageManagement {
  id: string;
  status?: PageStatusObject | null;
  type?: PageLayoutObject | null;
  enableRoleBased?: boolean | null;
  isText?: boolean | null;
  metaKeywords?: string[] | null;
  metaDescription?: string | null;
  content?: string | null;
  url?: string | null;
  title?: string | null;
  createdAt: string;
  updatedAt: string;
}

export interface PageManagementCreateDto {
  status?: PageStatusObject;
  type?: PageLayoutObject;
  enableRoleBased?: boolean;
  isText?: boolean;
  metaKeywords?: string[];
  metaDescription?: string;
  content?: string;
  url?: string;
  title?: string;
}

export interface PageManagementUpdateDto {
  status?: PageStatusObject;
  type?: PageLayoutObject;
  enableRoleBased?: boolean;
  isText?: boolean;
  metaKeywords?: string[];
  metaDescription?: string;
  content?: string;
  url?: string;
  title?: string;
}

export interface PageManagementResponse {
  data: PageManagement[];
  totalCount: number;
  page: number;
  limit: number;
  hasNextPage: boolean;
  hasPreviousPage: boolean;
}

// Filter and Sort Interfaces
export interface FilterPageManagementDto {
  title?: string;
  url?: string;
  status?: number;
  type?: number;
}

export interface SortPageManagementDto {
  orderBy?: keyof PageManagement;
  order?: "asc" | "desc";
}

export interface QueryPageManagementDto {
  page?: number;
  limit?: number;
  filters?: FilterPageManagementDto;
  sort?: SortPageManagementDto[];
}



